import { render, staticRenderFns } from "./CouponPoper.vue?vue&type=template&id=0c816fbe&scoped=true&lang=pug&"
import script from "./CouponPoper.vue?vue&type=script&lang=js&"
export * from "./CouponPoper.vue?vue&type=script&lang=js&"
import style0 from "./CouponPoper.vue?vue&type=style&index=0&id=0c816fbe&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c816fbe",
  null
  
)

export default component.exports